// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8a67c7c7","453":"bfd68fff","455":"9f4bef87","908":"1cb84f75","977":"fca93f89"}[chunkId] + ".chunk.js";
};